import type { WebUiRouteId } from '../routes';

export type MenuSection = 'status' | 'settings' | 'maintenance';

export type MenuGroup = {
  section: MenuSection;
  header: string;
  items: Array<{ id: WebUiRouteId; label: string }>;
};

export const MENU: MenuGroup[] = [
  {
    section: 'status',
    header: 'Status',
    items: [
      { id: 'status_system', label: 'System' },
      { id: 'status_interfaces', label: 'Ports' },
      { id: 'status_traffic', label: 'Traffic' },
      { id: 'status_poe', label: 'PoE' },
      { id: 'status_lacp', label: 'LACP' },
      { id: 'status_dhcp', label: 'DHCP Leases' },
      { id: 'status_log', label: 'Logging' },
      { id: 'status_ignition', label: 'Ignition' },
      { id: 'status_stp', label: 'Spanning Tree' },
      { id: 'status_dhcp_client', label: 'DHCP Client' },
      { id: 'status_lldp', label: 'LLDP' },
    ],
  },
  {
    section: 'settings',
    header: 'Settings',
    items: [
      { id: 'settings_system', label: 'System' },
      { id: 'settings_ignition', label: 'Ignition' },
      { id: 'settings_ports', label: 'Ports' },
      { id: 'settings_lacp', label: 'LACP' },
      { id: 'settings_vlan', label: 'VLAN' },
      { id: 'settings_multicast', label: 'Multicasts' },
      { id: 'settings_interfaces', label: 'Management Interfaces' },
      { id: 'settings_qos', label: 'QoS' },
      { id: 'settings_mirroring', label: 'Port Mirroring' },
      { id: 'settings_lldp', label: 'LLDP' },
      { id: 'settings_stp', label: 'Spanning Tree' },
      { id: 'settings_dhcp_server', label: 'DHCP Server' },
      { id: 'settings_dhcp_relay', label: 'DHCP Relay' },
      { id: 'settings_dhcp_inserter', label: 'DHCP Inserter' },
      { id: 'settings_poe', label: 'PoE' },
      { id: 'settings_ntp', label: 'NTP Client' },
      { id: 'settings_remote_logging', label: 'Remote Logging' },
      { id: 'settings_snmp', label: 'SNMP' },
      { id: 'settings_nat', label: 'NAT' },
      { id: 'settings_mqtt', label: 'MQTT' },
    ],
  },
  {
    section: 'maintenance',
    header: 'Maintenance',
    items: [
      { id: 'maintenance_users', label: 'Users' },
      { id: 'maintenance_settings', label: 'Configuration' },
      { id: 'maintenance_webserver', label: 'Webserver' },
      { id: 'maintenance_fwupdate', label: 'Software' },
    ],
  },
];
